import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c15d380a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ion-text-start" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_text = _resolveComponent("ion-text")!

  return (_openBlock(), _createElementBlock("table", null, [
    _createElementVNode("tr", null, [
      _createElementVNode("th", _hoisted_1, _toDisplayString(_ctx.type == "weekly" ? "Quarter" : "Year"), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numCells, (i) => {
        return (_openBlock(), _createElementBlock("th", {
          key: i,
          class: "ion-text-end"
        }, _toDisplayString(_ctx.type == "weekly" ? `W${i}` : _ctx.monthNames[i - 1]), 1))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trades, (row, index) => {
      return (_openBlock(), _createElementBlock("tr", {
        key: index,
        onClick: ($event: any) => (_ctx.changeIndex(index)),
        class: _normalizeClass(index == _ctx.selectedIndex ? 'highlight' : '')
      }, [
        _createElementVNode("td", null, [
          _createVNode(_component_ion_text, { color: "primary" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(row.period), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.trades, (trade) => {
          return (_openBlock(), _createElementBlock("td", {
            key: trade.id,
            class: "ion-text-end"
          }, [
            _createVNode(_component_ion_text, {
              color: trade.profit > 0 ? 'green' : 'danger'
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(trade.profit), 1)
              ]),
              _: 2
            }, 1032, ["color"])
          ]))
        }), 128)),
        (row.trades.length < _ctx.numCells)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.numCells - row.trades.length, (index) => {
              return (_openBlock(), _createElementBlock("td", { key: index }, " "))
            }), 128))
          : _createCommentVNode("", true)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}